import { render, staticRenderFns } from "./html-block.vue?vue&type=template&id=61a0c4f6"
import script from "./html-block.vue?vue&type=script&lang=js"
export * from "./html-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports